import { GenericWorksheet, ReconciliationWorksheet, Worksheet, WorksheetTypeEnum } from '../types/worksheet';

export function isReconciliationWorksheet(worksheet: Worksheet): worksheet is ReconciliationWorksheet {
    return worksheet.type === WorksheetTypeEnum.RECONCILIATION;
}

export function isGenericWorksheet(worksheet: Worksheet): worksheet is GenericWorksheet {
    return worksheet.type === WorksheetTypeEnum.GENERIC;
}
